import { useTranslation } from 'next-i18next';
import { Dispatch, SetStateAction } from 'react';
import Button from '@components/Button/Button';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/Bookmarks/Bookmarks.styles';
type PropsType = {
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
};
const Bookmarks = ({
  activeIndex,
  setActiveIndex
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const isActive = (_activeIndex): boolean => activeIndex === _activeIndex;
  return <div sx={styles.container}>
      <Button variant="link" size="small" onClick={() => setActiveIndex(0)} addSx={styles.activeButton(isActive(0))}>
        {t('button.map')}
      </Button>
      <Button variant="link" size="small" onClick={() => setActiveIndex(1)} addSx={styles.activeButton(isActive(1))}>
        {t('button.list')}
      </Button>
    </div>;
};
export default Bookmarks;